import { _ } from "~/i18n";
import { icon, node } from "~/util/dom";

/**
 * Ovladaci prvky do mapy v galerii
 */
export default class ControlBestfit extends SMap.Control.Visible {
	constructor() {
		super();
		this._node = node("div", { className: "control-bestfit map-control" });
		this._btn = node("button", { className: "icon bestfit", title: _("gallery.bestfit") });
		this._btn.setAttribute("data-log-ignore", "1");
		this._btn.appendChild(icon("bestfit"));
		this._btn.addEventListener("click", this, false);
		this._node.appendChild(this._btn);
	}

	destroy() {
		this._btn.removeEventListener("click", this, false);
		Mapy.Util.clear(this._node);
	}

	getContainer() {
		return this._node;
	}

	handleEvent() {
		const customEvent = new CustomEvent("best-fit");

		this._node.dispatchEvent(customEvent);
	}
}
